import type { Coordinates } from './types';

type TravelMode = 'driving' | 'walking' | 'bicycling' | 'transit';

export const useGoogleMap = () => {
    const openGoogleMap = ({ latitude, longitude }: Coordinates) => {
        const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
        window.open(url, '_blank');
    };

    const openDirections = ({ latitude, longitude }: Coordinates, travelMode: TravelMode = 'walking') => {
        const url = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}&travelmode=${travelMode}`;
        window.open(url, '_blank');
    };

    return {
        openGoogleMap,
        openDirections,
    };
};
